import React from "react";
import TablePageSize from "../../../../../../common/components/TablePageSize";
import { Table, Icon } from "antd";

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const RequestsTable = props => {
  const {
    requests,
    pagination,
    onPageChange,
    renderColumns,
    requestsLoading,
    handleClickRow,
    onPageSizeChange,
    sortByColumn
  } = props;

  return (
    <div className="orders__table">
      <Table
        locale={{
          emptyText: requestsLoading ? placeholder : "Заявок нет..."
        }}
        columns={renderColumns()}
        dataSource={requests}
        rowKey="id"
        pagination={{
          pageSize: pagination ? pagination.limit : 0,
          total: pagination ? pagination.total : 0,
          current: pagination ? pagination.page : 0
        }}
        onRow={handleClickRow}
        onChange={(pag, filters, sorter) => {
          //На основе аргументов вызывать разные колбеки изменений (страница, кол-во результатов, сортировку)
          if (
            pag.pageSize !== pagination.limit ||
            pag.current !== pagination.page
          ) {
            onPageChange(pag);
          } else if (sorter) {
            sortByColumn(sorter);
          }
        }}
        // rowSelection={rowSelection}
        scroll={{ x: "max-content" }}
        rowClassName={(record, index) =>
          !record.watched
            ? "request-row___unwatched request-row"
            : "request-row"
        }
      />
      {requests && requests.length > 0 ? (
        <TablePageSize
          pages={pagination.limit}
          changePaginationSize={onPageSizeChange}
        />
      ) : null}
    </div>
  );
};

export default RequestsTable;
